import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/DBContext';

import LandingPage from './screens/landingPage/landingPage';
import AboutPage from './screens/landingPage/aboutPage';
import PricingPage from './screens/landingPage/pricingPage';
import ContactPage from './screens/landingPage/contactPage';
import TermsPage from './screens/termsPage/termsPage';
import PrivacyPage from './screens/privacyPage/privacyPage';
import PDFPage from './screens/resourcesPage/pdfPage';

import Loginpage from './screens/loginPage/loginPage';

import SignupPage from './screens/signupPage/selectRole';
import FamilySignupPage from './screens/signupPage/signupPage';
import EmailVerificationPage from './screens/emailverPage/emailverPage';
import ForgotPasswordPage from './screens/forgotpasswordPage/forgotpasswordPage';
import BusinessSignUpPage from './screens/businessSignUpPage/businessSignUpPage';

import HomePage from './screens/homePage/homePage';
import ChatPage from './screens/chatPage/chatPage';
import BlogPage from './screens/blogPage/blogPage';
import ServicePage from './screens/servicePage/servicePage';
import SubscriptionPage from './screens/subscriptionPage/subscriptionPage';
import ServiceDetailPage from './screens/serviceDetailPage/serviceDetailPage';
import BlogDetailPage from './screens/blogDetailPage/blogDetailPage';
import ResourcesPage from './screens/resourcesPage/resourcesPage';

import AdminDashboardPage from './screens/adminDashboardPage/adminDashboardPage';
import AdminProductPage from './screens/adminProductPage/adminProductPage';
import AdminWidgetPage from './screens/adminWidgetPage/adminWidgetPage';
import AdminUserPage from './screens/adminUserPage/adminUserPage';
import AdminBusinessPage from './screens/adminBusinessPage/adminBusinessPage';
import AdminLocalAuthorityPage from './screens/adminLocalAuthorityPage/adminLocalAuthorityPage';
import AdminPDFPage from './screens/adminPDFPage/adminPDFPage';

import BusinessProfilePage from './screens/businessProfilePage/businessProfilePage';
import BusinessServicePage from './screens/businessServicePage/businessServicePage';  

import LocalAuthoritySignUpPage from './screens/localAuthoritySignUpPage/localAuthoritySignUpPage.jsx';
import LocalAuthorityUserPage from './screens/localAuthorityUserPage/localAuthorityUserPage.jsx';
import LocalAuthorityBusinessPage from './screens/localAuthorityBusinessPage/localAuthorityBusinessPage.jsx';

import ApprovalPendingPage from './screens/approvalPendingPage/approvalPendingPage.jsx';
import CreateBlogPage from './screens/createBlogPage/createBlogPage';
import EditBlogPage from './screens/editBlogPage/editBlogPage';
import MapPage from './screens/mapPage/mapPage';
import ProductsPage from './screens/productsPage/productsPage';
import OrgDashboardPage from './screens/orgDashboardPage/orgDashboardPage';
import About from './components/about/page';

import PrivateRoute from './route/privateRoute';
import ProtectedRoute from './route/protectedRoute';
import MainLayout from './screens/MainLayout';

import ResourcesPage1 from './screens/resourcesPage/resource1';
import ResourcesPage2 from './screens/resourcesPage/resource2';
import ResourcesPage3 from './screens/resourcesPage/resource3';
import ResourcesPage4 from './screens/resourcesPage/resource4';
import AuthPricingPage from './screens/pricingPage/AuthPricingPage';

import ImportPage from './screens/importPage/importPage.jsx';
function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/login" element={<Loginpage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/emailverification" element={<EmailVerificationPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pa-signup" element={<FamilySignupPage />} />
          <Route path="/business-signup" element={<BusinessSignUpPage />} />
          <Route path="/la-signup" element={<LocalAuthoritySignUpPage />} />
          <Route path="/approval-pending" element={<ApprovalPendingPage />} />

          {/* Protected Routes with MainLayout */}
          <Route element={<PrivateRoute />}>
            <Route element={<MainLayout />}>
              {/* Auth Routes (Only need authentication) */}
              <Route path="/auth-pricing" element={<AuthPricingPage />} />

              {/* Routes that need subscription */}
              <Route element={<ProtectedRoute allowedRoles={['family', 'business', 'admin', 'local-authority']} />}>
                <Route path="/dashboard" element={<HomePage />} />
              </Route>

              {/* Family & Business Routes */}
              <Route element={<ProtectedRoute allowedRoles={['family', 'business', 'admin', 'local-authority']} />}>
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/service" element={<ServicePage />} />
                <Route path="/service/:id" element={<ServiceDetailPage />} />
                <Route path="/blog/:id" element={<BlogDetailPage />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/resources/information" element={<ResourcesPage1 />} />
                <Route path="/resources/advice" element={<ResourcesPage2 />} />
                <Route path="/resources/resource" element={<ResourcesPage3 />} />
                <Route path="/resources/guidance" element={<ResourcesPage4 />} />
                <Route path="/pdf" element={<PDFPage />} />
              </Route>

              {/* Admin Only Routes */}
              <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
                <Route path="/admin" element={<AdminDashboardPage />} />
                <Route path="/adminproduct" element={<AdminProductPage />} />
                <Route path="/adminwidget" element={<AdminWidgetPage />} />
                <Route path="/admin-user" element={<AdminUserPage />} />
                <Route path="/admin-business" element={<AdminBusinessPage />} />
                <Route path="/admin-localauthority" element={<AdminLocalAuthorityPage />} />
                <Route path="/admin-pdf" element={<AdminPDFPage />} />
                <Route path="/createblog" element={<CreateBlogPage />} />
                <Route path="/editblog/:id" element={<EditBlogPage />} />
                <Route path="/import4420" element={<ImportPage />} />

              </Route>

              {/* Business Only Routes */}
              <Route element={<ProtectedRoute allowedRoles={['business']} />}>
                <Route path="/business-profile" element={<BusinessProfilePage />} />
                <Route path="/business-service" element={<BusinessServicePage />} />
              </Route>

              {/* Local Authority Only Routes */}
              <Route element={<ProtectedRoute allowedRoles={['local-authority']} />}>
                <Route path="/la-users" element={<LocalAuthorityUserPage />} />
                <Route path="/la-business" element={<LocalAuthorityBusinessPage />} />
              </Route>

              {/* Organization Routes */}
              <Route element={<ProtectedRoute allowedRoles={['business', 'local-authority']} />}>
                <Route path="/orgDashboard" element={<OrgDashboardPage />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
